import styled from "styled-components";

export const InvoicePeriodCont = styled.div`
    margin: 0 0 24px 0;
    display: flex;
`;
export const Or = styled.span`
    margin: 40px 8px 0 8px;
    font-size: 14px;
`;